export const appsUrl = process.env.REACT_APP_APPS_URL || 'https://apps.liminalityhub.com';
export const studio = {
  email: 'info@liminalityhub.com',
  founders: ['Luca Langella', 'Michele Coppola'],
};
export const team = [
  {
    name: 'Luca Langella',
    initials: 'LL',
    image: '/images/luca.png',
    role: 'Co-Founder',
    bio: 'Shapes product ideas and builds websites and apps. He attended the Apple Developer Academy and ARTE research programme, and studied business and international management at the University of Naples Federico II.',
    focus: 'Product strategy · Websites and apps',
    linkedin: 'https://www.linkedin.com/in/luca-langella-4a1b54250',
    github: 'https://github.com/Lucalangella',
  },
  {
    name: 'Michele Coppola',
    initials: 'MC',
    image: '/images/michele.png',
    role: 'Co-Founder',
    bio: 'Designs and builds apps for iPhone, Mac, and Apple Vision Pro. He attended the Apple Developer Academy and ARTE research programme and studied materials engineering at the University of Naples Federico II.',
    focus: 'App development · iOS, macOS & visionOS',
    linkedin: 'https://www.linkedin.com/in/michele-coppola/',
    github: 'https://github.com/MicheleCoppola17',
  },
];
export const projects = [
  { name: 'GaussianCapture', type: 'iOS & macOS · App Store', image: '/images/gaussiancapture-icon.png', alt: 'GaussianCapture app icon', url: 'https://apps.apple.com/app/gaussiancapture/id6765473250', cta: 'View on App Store', description: 'Turn a single photo into a 3D Gaussian splat on your iPhone or Mac. Processing stays on your device.' },
  { name: 'ShipKit', type: 'macOS app · Product website', image: '/images/shipkit-icon.png', alt: 'ShipKit app icon', url: 'https://getshipkit.app', cta: 'Visit website', description: 'A Mac app for preparing and distributing your Mac apps.' },
  { name: 'Curtain', type: 'macOS app · Product website', image: '/images/curtain-icon.png', alt: 'Curtain app icon', url: 'https://getcurtain.app', cta: 'Visit website', description: 'Hide your Mac desktop icons with one click.' },
];
